"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAttributeAutocomplete = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("../../../../../components");
exports.StyledAttributeAutocomplete = (0, styled_components_1.default)((components_1.AutocompleteSelector)) `
  width: min(100%, 18rem);

  &.MuiAutocomplete-root > .MuiFormControl-root > .MuiInputBase-root.MuiOutlinedInput-root {
    width: 100%;
  }
`;
